// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drawing-tools-section {
  border-bottom: 1px solid var(--border-tertiary);
}

.drawing-tools-section:last-child {
  border-bottom: none;
}

.drawing-tools-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-tertiary);
  cursor: pointer;
  user-select: none;
}

.drawing-tools-section .drawing-tools-row {
  border-bottom: none;
}

.drawing-tools-row:hover {
  background: var(--color-brand-hover2, #f9e2d6);
}

.drawing-tools-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.drawing-tools-icon svg {
  width: 20px;
  height: 20px;
}

.drawing-tools-icon svg path {
  fill: var(--accent-secondary);
}

.drawing-tools-row-active .drawing-tools-icon svg path {
  fill: var(--color-brand);
}

.drawing-tools-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.drawing-tools-arrow-up {
  transform: rotate(180deg);
}

.drawing-tools-content {
  padding: 8px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.drawing-tools-style-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.drawing-tools-style-label {
  color: var(--text-secondary);
}

@container (max-width: 600px) {
  .drawing-tools-popup {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/settings/DrawingToolsSettings.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".drawing-tools-section {\n  border-bottom: 1px solid var(--border-tertiary);\n}\n\n.drawing-tools-section:last-child {\n  border-bottom: none;\n}\n\n.drawing-tools-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-tertiary);\n  cursor: pointer;\n  user-select: none;\n}\n\n.drawing-tools-section .drawing-tools-row {\n  border-bottom: none;\n}\n\n.drawing-tools-row:hover {\n  background: var(--color-brand-hover2, #f9e2d6);\n}\n\n.drawing-tools-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.drawing-tools-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.drawing-tools-icon svg path {\n  fill: var(--accent-secondary);\n}\n\n.drawing-tools-row-active .drawing-tools-icon svg path {\n  fill: var(--color-brand);\n}\n\n.drawing-tools-actions {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.drawing-tools-arrow-up {\n  transform: rotate(180deg);\n}\n\n.drawing-tools-content {\n  padding: 8px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.drawing-tools-style-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.drawing-tools-style-label {\n  color: var(--text-secondary);\n}\n\n@container (max-width: 600px) {\n  .drawing-tools-popup {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
